import { Injectable } from '@angular/core';
import { forkJoin, Observable, of } from 'rxjs';
import { PublicService } from './public.service';

@Injectable({
  providedIn: 'root'
})
export class ResourceInitializerService {

  public resourceHolder: any = {};

  constructor(private publicService: PublicService) {}

  load() {
    this.publicService.getAllProvinceRer().subscribe((response) => {
      this.addResource('province', response);
    });
  }

  addResource(key: string, value: any) {
    this.resourceHolder[key] = value;
  }

  getResource(key: string): any {
    return this.resourceHolder[key];
  }

}
